import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";

export interface MessageProps {
  id: string;
  content: string;
  isBot: boolean;
  timestamp: Date;
  responseId?: string;
}

const Message: React.FC<MessageProps> = ({ content, isBot }) => {
  return (
    <div className={`flex ${isBot ? "justify-start" : "justify-end"}`}>
      <div
        className={`max-w-[85%] rounded-2xl shadow-sm ${
          isBot
            ? "bg-white border border-gray-200"
            : "bg-brand-primary text-white"
        }`}
      >
        <div className="p-4">
          {isBot ? (
            <div className="prose prose-sm max-w-none">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                  code({ node, inline, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || "");
                    const language = match ? match[1] : "text";

                    return !inline ? (
                      <div className="rounded-md overflow-hidden my-4">
                        <SyntaxHighlighter
                          language={language}
                          style={vscDarkPlus}
                          customStyle={{ borderRadius: "0.375rem" }}
                          showLineNumbers
                          {...props}
                        >
                          {String(children)}
                        </SyntaxHighlighter>
                      </div>
                    ) : (
                      <code
                        className="px-1 py-0.5 bg-gray-100 rounded font-mono text-sm"
                        {...props}
                      >
                        {children}
                      </code>
                    );
                  },
                  a: ({ node, ...props }) => (
                    <a
                      {...props}
                      className="text-brand-primary hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  ),
                }}
              >
                {content}
              </ReactMarkdown>
            </div>
          ) : (
            <p className="whitespace-pre-wrap">{content}</p>
          )}
        </div>
        <div className="flex justify-between items-center px-4 py-2 border-t border-gray-100">
          <span className="text-xs text-gray-500">
            {new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Message;
